import {BackendError, EventHappening} from "@/lib/types";
import EventCard from "@/lib/components/EventCard";
import {useSession} from "@/lib/auth/auth";
import Page from "@/lib/components/Page";
import {dataRetryPolicy, fetchBackend} from "@/lib/backend";
import ErrorPage from "@/lib/components/ErrorPage";
import {useQuery} from "@tanstack/react-query";
import SpinnerPage from "@/lib/components/SpinnerPage";
import {useLocalSearchParams, useRouter} from "expo-router";
import Header from "@/lib/components/Header";
import ActionButton from "@/lib/components/ActionButton";
import {Platform, Pressable, StyleSheet, TextInput, View} from "react-native";
import Icon from "@/lib/components/Icon";
import {Color} from "@/lib/styles";
import globstyles from "@/lib/globstyles";
import {useEffect, useRef, useState} from "react";

const searchbarHeight = 42;

export default function Index() {
    const {session, isLoading} = useSession();
    const router = useRouter();
    const searchInput = useRef<TextInput>(null);

    const {event_id} = useLocalSearchParams();

    const [searchQuery, setSearchQuery] = useState("");

    const {data, isPending, error} = useQuery<EventHappening[], BackendError>({
        queryKey: ['event', session],
        queryFn: () => fetchBackend("/event", "GET", session),
        retry: dataRetryPolicy,
        staleTime: 1000 * 60 * 15,
        enabled: !isLoading,
    })

    // redirect when landed on a opengraph metadata page.
    useEffect(() => {
        if (!event_id) {
            return;
        }
        router.replace(`/e`);
        router.push(`/e/${event_id}`);
    }, [event_id, router]);

    if (error && error.name === "ApiError") {
        return <ErrorPage error={error}></ErrorPage>;
    } else if (!!error) {
        const err = new Error("Klarer ikke hente eventer akkurat nå.\n\nSjekk at du er tilkoblet Internett og prøv igjen.\n\nOriginal feilmelding: " + error.message);
        return <ErrorPage error={err}></ErrorPage>;
    }

    if (isPending) return <SpinnerPage/>;

    return (
        <Page scrollable={true}>
            <View style={styles.searchBar}>
                <Pressable focusable={false} onPress={() => router.navigate(`/e/search`)}>
                    <Icon kind={"logo"} size={searchbarHeight} color={Color.Yellow}/>
                </Pressable>
                <TextInput style={[globstyles.formTextInput, styles.searchField]}
                           placeholder={"Søk etter eventer"}
                           placeholderTextColor={Color.FadedText}
                           value={searchQuery}
                           onChangeText={(query) => {
                               setSearchQuery(query);
                           }}
                           inputMode={"search"}
                           returnKeyType={"search"}
                           autoFocus={Platform.OS === "web"}
                           focusable={true}
                           keyboardAppearance={"dark"}
                           submitBehavior={"submit"}
                           onSubmitEditing={() => {
                               router.navigate(`/e/search?query=${searchQuery}`);
                               setSearchQuery("");
                               searchInput.current?.focus();
                           }}
                />
                {!!session &&
                    <ActionButton
                        icon={"plus"}
                        title={"Ny"}
                        height={searchbarHeight}
                        onPress={() => {
                            router.navigate(`/e/create`);
                        }}

                    />
                }
            </View>

            {(!data || data.length === 0) && (
                <Header title={"Ingen eventer å vise."}/>
            )}

            {data.map(event => <EventCard key={event.event_id} event={event}></EventCard>)}
        </Page>
    );
}

export const styles = StyleSheet.create({
    searchBar: {
        flexDirection: "row",
        gap: 8,
        height: searchbarHeight,
        marginVertical: 4,
    },
    searchField: {
        width: "100%",
        flexShrink: 1,
    },
})